import { render, staticRenderFns } from "./ArtistsManagers.vue?vue&type=template&id=26ccd8cb&scoped=true&"
import script from "./ArtistsManagers.vue?vue&type=script&lang=js&"
export * from "./ArtistsManagers.vue?vue&type=script&lang=js&"
import style0 from "./ArtistsManagers.vue?vue&type=style&index=0&id=26ccd8cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ccd8cb",
  null
  
)

export default component.exports